/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EncryptionService } from '../../services/encryption.service';
import { environment } from '../../../environments/environment';
import { safeLocalStorageGetItem } from '../utils/safe-storage.util';
import { buildHmacHeaders, isLogibidsApiRequest } from '../helpers/hmac.helper';

@Injectable({
  providedIn: 'root',
})
export class SetInterceptor implements HttpInterceptor {
  encryptedString: any;
  constructor(private _encryptionService: EncryptionService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clonedReq = this.handleRequest(req);
    return next.handle(clonedReq);
  }

  handleRequest(req: HttpRequest<any>) {
    const token = this.getTokenForRequest();
    const language =
      safeLocalStorageGetItem('language') ||
      safeLocalStorageGetItem('lang') ||
      'en';
    const modifiedBody = req.body;
    const fcm = this._encryptionService.decryptLocalStorage('fcmToken') ?? '';
    const isFormData =
      (req.method.toLowerCase() === 'post' ||
        req.method.toLowerCase() === 'put') &&
      req.body instanceof FormData;

    let headers = new HttpHeaders({
      authorization: token ? `Bearer ${token}` : '',
      devicetype: 'web',
      'x-device-type': 'WEB',
      'Accept-Language': language,
      'x-portal': 'ADMIN',
    });

    if (!isFormData) {
      headers = headers
        .set('Content-Type', 'application/json')
        .set('x-device-token', fcm);
    }

    if (
      environment.hmacSecretKey &&
      isLogibidsApiRequest(req.urlWithParams, environment.base_url)
    ) {
      const hmacHeaders = buildHmacHeaders({
        method: req.method,
        url: req.urlWithParams,
        body: req.body,
        secret: environment.hmacSecretKey,
      });
      // headers = headers
      //   .set('x-signature', hmacHeaders['x-signature'])
      //   .set('x-timestamp', hmacHeaders['x-timestamp']);
    }

    return req.clone({
      headers,
      body: isFormData ? req.body : modifiedBody,
    });
  }

  getTokenForRequest(): string | null {
    return this._encryptionService.decryptLocalStorage(environment.storageKey);
  }
}
